import React from 'react'
import { useTranslation } from 'react-i18next'
import HeroImg from '../../../assets/images/company-formation/offshore-company-formation/hero-img.png'
import BannerImg from '../../../assets/images/company-formation/offshore-company-formation/banner-img.png'
import BreadCrumbs from "../../../components/BreadCrumbs/BreadCrumbs";
import HeroRightImage from "../../../components/Constant/HeroRightImage/HeroRightImage";
import BannerPageImg from "../../../components/Constant/Banner Page Img/BannerPageImg";
import PageList from "../../../components/Constant/List/List";
import { TiTick } from "react-icons/ti";
import { GoDotFill } from "react-icons/go";
import FAQList from "../../../components/Constant/FAQCard/FAQCard";
import CTA from "../../../components/Constant/cta/CTA";
import SEO from "../../../utils/SEO";

function CompanyFormationDominica() {
    const { t } = useTranslation();
    const tp = (k, d) => t(`pages.dominica-company-formation.${k}`, d);
    const obj = (k) => tp(k, { returnObjects: true });
    const withIcon = (k, icon) => (obj(k) || []).map((it) => ({ ...it, icon }));

    const BreadCrumbsData = [
        { name: tp('breadcrumb.home', 'Offshore Advisory'), link: '/' },
        { name: tp('breadcrumb.self', 'Company Formation in Dominica'), link: '/company-formation-dominica' },
    ];

    return (
        <main className='main'>
            <SEO
                title={tp('seo.title')}
                description={tp('seo.description')}
                keywords={tp('seo.keywords')}
                url="/dominica-company-formation"
            />
            <section className='section'>
                <BreadCrumbs data={BreadCrumbsData}/>

                <div className='container'>
                    <h1 className='section-title'>{tp('h1')}</h1>
                    <br/>
                    <div className='grid-container'>
                        <div className='flex-start'>
                            <h3 className='page-subtitle'>{tp('subtitle')}</h3>
                            <p className='page-paragraph' dangerouslySetInnerHTML={{ __html: tp('intro') }} />
                            <PageList items={(obj('checklist') || []).map((title) => ({ title, icon: TiTick }))} />
                        </div>

                        <HeroRightImage src={HeroImg}/>
                    </div>
                    <BannerPageImg src={BannerImg}/>
                    <br/><br/>

                    <div className='flex-start'>
                        <h3 className='page-title'>{tp('why.title')}</h3>
                        <PageList items={withIcon('why.items', GoDotFill)} />

                        <h3 className='page-title'>{tp('features.title')}</h3>
                        <PageList items={withIcon('features.items', GoDotFill)} />

                        <h3 className='page-title'>{tp('uses.title')}</h3>
                        <PageList items={withIcon('uses.items', GoDotFill)} />
                        <p className='page-subtitle'>{tp('timeline')}</p>

                        <h3 className='page-title'>{tp('advantages.title')}</h3>
                        <PageList items={withIcon('advantages.items', GoDotFill)} />
                    </div>

                    <FAQList title={tp('faq.title')} data={obj('faq.items')} />

                    <CTA
                        title={tp('cta.title')}
                        description={tp('cta.description')}
                        buttonText={tp('cta.button')}
                        buttonLink="/consultation"
                    />
                </div>
            </section>
        </main>
    )
}

export default CompanyFormationDominica
